
import "./Room.css"
import { useState } from "react"
import Private from '../Images/logo.png'
import Chat from "../Chat/Chat.js"
import Navigation from "../RoomNavigation/Navigation.js"
import LoadingModel from "../3DModels/LoadingModel.js"
import PopMenu from "../RoomPopUp/RoomPopUp.js"
import UserHome from "../UserHome/UserHome.js"









export default function Room({username,userId}) {

  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [publicRooms, setPublicRooms] = useState([
    {
      name: "En", type: "Public", members: null, image: require("../Images/UK.png"),owner:'Founder',
      saloons:
        [{
          vocal:
            [{
              name: "Founder's Vocal Saloon",
              messages:
                [{
                  text: 'Hello and welcome to the first vocal saloon.',
                  sender: "Founder",
                  timestamp: "10:30"
                }],
              users: []
            }, {
              name: "Founder's Saloon 2", users: [],
              messages:
                [{
                  text: 'test Drive founder says Hi',
                  sender: "Founder",
                  timestamp: "10:30"
                }]
            }]
        }],
    }
  ]);

  const [chat, setChat] = useState(null);
  const [view, setView] = useState("");
  const [server, setServer] = useState(null)
  const clickRomm = (room) => {
    setServer(room)
    setChat(null)
    setView("")
  }

  const handleAddRoom = (roomName) => {
  
    setPublicRooms([...publicRooms, { name: roomName, owner: "le me", }]);
    const popUpToClose=document.getElementById("PopUp-Wrapper");
    console.log(popUpToClose+'ok')
    if(popUpToClose){
          popUpToClose.style.display="none"
    }
  };
  const clickAdd=()=>{
    const popUp=document.getElementById("PopUp-Wrapper");
    console.log(popUp+'ok')
    if(popUp){
          popUp.style.display="flex"
          setIsPopUpOpen(true)
    }
  }

  return (
    <>     <PopMenu
              
    isOpen={isPopUpOpen}
    onClose={() => setIsPopUpOpen(false)}
    onAddRoom={handleAddRoom}
    setIsPopUpOpen={setIsPopUpOpen}
  />
    <div className="Room-Wrapper">
      <div className="Dashboard-Wrapper">
        <div className="Dashboard">
          <div className="Dashboard-Tools">
            <div className="NavButtons-Wrapper">
              <button onClick={() => { setView("Private") }}>
                <img src={Private} alt="Non" />
              </button>
              <button onClick={clickAdd}>
                <p style={{ width: "clamp(55px,10vw,40px)", fontSize: "30px", margin: "0" }}>+</p>
              </button>
         
              {publicRooms
                ? publicRooms.map((room, roomIndex) => (
                  <button key={roomIndex} onClick={() => clickRomm(room)}>
                    <img src={room.image} alt={room.name.slice(0, 5)} />
                    <span>{room.name.slice(0, 4)}</span>
                  </button>
                ))
                : null}

            </div>
          </div>
          {
            server && view === "" ? 
              <div className="Display-Wrapper">
                <>
                  <Navigation room={server} setChat={setChat} />
                  {chat ? <Chat chat={chat} setChat={setChat} publicRooms={publicRooms} setPublicRooms={setPublicRooms} /> 
                  :
                  <div className="Display-Loading"><h1 >Welcome to the chat room</h1><LoadingModel/></div>}
                </>
              </div>
            : 
              <UserHome username={username}/>
          }
        </div>
      </div>

    </div>
    </>
  )
}